import React, { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import './styles/styles.scss';

import { flex } from '@/styles/theme';
import { FullscreenLoader, LargeLoader, ToastContainer } from '@/components/common';
import { ModalContainer, ModalProvider, useAppDispatch, useDebouncedResizeObserver } from './hooks';
import { Navigation } from '@/components/layout/navigation';
import { Routes } from '@/components/layout/routes';
import { DEBOUNCE_RESIZE_OBSERVER_DELAY } from './config/variables';
import { setIsMobileScreenSize, updateViewMode } from './store/slices/utilsSlice';
import { isMobileHelper } from './helpers';
import VideoStateProvider from './components/common/video/settings/state';
import LayoutContainer from './components/layout/layout-container/LayoutContainer';

const App = (): React.ReactElement => {
  const dispatch = useAppDispatch();

  const { ref } = useDebouncedResizeObserver({
    wait: DEBOUNCE_RESIZE_OBSERVER_DELAY,
    onResize: ({ width }) => {
      if (!width) return;
      dispatch(updateViewMode());
      dispatch(setIsMobileScreenSize(isMobileHelper(width)));
    },
  });

  return (
    <div ref={ref} className={`max-vh-100 ${flex.column}`}>
      <Router>
        <Navigation />
        <LayoutContainer>
          <VideoStateProvider>
            <ModalProvider>
              <Suspense fallback={<LargeLoader />}>
                <Routes />
              </Suspense>
              <ModalContainer />
            </ModalProvider>
          </VideoStateProvider>
        </LayoutContainer>
      </Router>
      <ToastContainer />
      <FullscreenLoader />
    </div>
  );
};
export default App;
